import { platformRole } from "@/app/registry";
import { useSession } from "@/app/session";
import { useAccess } from "@/app/shell/planAccess";

/** Who has alerts: admins, and everyone else whose plan is active (employees never). */
export function useAlertsEnabled(): boolean {
  const { user } = useSession();
  const access = useAccess();
  const role = platformRole(user?.role);
  if (!user || role === "employee") return false;
  return role === "admin" || access?.active === true;
}
